import LightNavbar from "./components/LightNavbar";
import LightHero from "./components/LightHero";
import LightServices from "./components/LightServices";
import LightSolutions from "./components/LightSolutions";
import LightProcess from "./components/LightProcess";
import LightCases from "./components/LightCases";
import LightPricing from "./components/LightPricing";
import LightFAQ from "./components/LightFAQ";
import LightContact from "./components/LightContact";
import LightFooter from "./components/LightFooter";
import SeoHead from "@/components/feature/SeoHead";
import { home } from "@/content";

/**
 * Главная. Один набор компонентов на обе темы: цвета переключаются
 * dark:-вариантами, адрес не меняется.
 */
export default function HomePage() {
  return (
    <>
      <SeoHead
        title={home.seo.title}
        description={home.seo.description}
        keywords={home.seo.keywords}
        canonicalPath={home.seo.canonicalPath}
      />
      <div className="min-h-screen font-sans bg-[#FAFAF8] dark:bg-[#0A0A0A]">
        <LightNavbar />
        <main>
          <LightHero />
          <LightServices />
          <LightSolutions />
          <LightProcess />
          <LightCases />
          <LightPricing />
          <LightFAQ />
          <LightContact />
        </main>
        <LightFooter />
      </div>
    </>
  );
}
